import { Component, Input } from '@angular/core';

@Component({
  selector: 'links-item',
  templateUrl: 'links-item.html',
  styleUrls: ['links-item.scss'],
  standalone: false
})
export class LinksItemComponent {
  @Input() link;
  @Input() spaceBetweenElements;

  constructor(
  ) {
  }


}
